import { Component, ViewChild } from '@angular/core';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { PackageService } from 'src/app/private/services/package.service';
import { MessageService } from 'primeng/api';
import { CreatePackageComponent } from "../../components/packages/create-package/create-package.component";
import { DeletePackageComponent } from "../../components/packages/delete-package/delete-package.component";

@Component({
  selector: 'app-packages',
  imports: [ToolBarComponent, SharedModule, CreatePackageComponent, DeletePackageComponent],
  templateUrl: './packages.component.html',
  styleUrl: './packages.component.scss'
})
export class PackagesComponent {

  showAddModal = false;
  packages: any[] = [];
  selectedPackage : any;
  showEditModal = false;
  showDeleteModal = false;
  @ViewChild('actionMenu') actionMenu: any;

  constructor(
    private localStorage: LocalStorageService,
    private packageService: PackageService,
    private messageService: MessageService

  ) {
  }

  ngOnInit() {
    this.loadPackages();
  }


  totalRecords = 0;
  rows = 50;
  loading = false;
  
  actionItems: any[] = [];

  openAddModal() {
    this.showAddModal = true;
  }

  openMenu(event: Event, orgpackage: any) {
    this.selectedPackage = orgpackage;
    this.actionItems = [
   
      {
        label: 'Edit',
        icon: 'pi pi-pencil',
        command: () => {
          this.showEditModal = true;

        }
      },
      {
        label: 'Delete',
        icon: 'pi pi-trash',
        styleClass: 'delete-menu-item',
        command: () => {
          this.showDeleteModal = true;
        }
      }
    ];
    this.actionMenu.toggle(event);
  }

  loadPackages() {

    this.loading = true;
    const data = {};
    this.packageService.getAllPackage(data).subscribe({
      next: (res) => {
        this.packages = res || [];
        this.totalRecords = this.packages.length;
        this.loading = false;
      },
      error: (err) => {
        console.error('❌ Failed to fetch packages:', err);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load packages' });
        this.loading = false;
      }
    });

  }

  getAllFeatures(featues : any[]) {
    return featues.map((feature: any) => feature).join(', ');
  }

  closeAddModal() {
    this.showAddModal = false;
  }
}
